if (!customElements.get('mini-cart-bubble')) {
  customElements.define(
    'mini-cart-bubble',
    class MiniCartBubble extends HTMLElement {
      connectedCallback() {
        this.pill = this.querySelector('.mini-cart-bubble__pill');
        this.thumbs = this.querySelector('.mini-cart-bubble__thumbs');
        this.count = this.querySelector('.mini-cart-bubble__count');
        this.total = this.querySelector('.mini-cart-bubble__total');

        this.pill.addEventListener('click', this.onClick.bind(this));

        this.refresh();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }

        // A back/forward navigation can restore this page from the browser's
        // cache without re-running this script, leaving the bubble showing
        // whatever cart state it last had. Force a fresh check when that happens.
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) this.refresh();
        });
      }

      onClick() {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
          return;
        }
        window.location.href = this.dataset.cartUrl || '/cart';
      }

      refresh() {
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => this.render(cart))
          .catch(() => {});
      }

      formatMoney(cents) {
        const amount = cents / 100;
        try {
          return amount.toLocaleString(undefined, {
            style: 'currency',
            currency: window.Shopify?.currency?.active || 'USD',
          });
        } catch (e) {
          return `$${amount.toFixed(2)}`;
        }
      }

      render(cart) {
        if (!cart || cart.item_count === 0) {
          this.classList.remove('mini-cart-bubble--visible');
          return;
        }

        this.thumbs.innerHTML = cart.items
          .slice(0, 3)
          .map(
            (item) =>
              `<img class="mini-cart-bubble__thumb" src="${item.image}" alt="" width="32" height="32" loading="lazy">`
          )
          .join('');

        this.count.textContent = `${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`;
        this.total.textContent = this.formatMoney(cart.total_price);

        this.classList.add('mini-cart-bubble--visible');
      }
    }
  );
}
